<div class="edit-slot-page-container">
  <mwo-scheduler-modifier-header (onBreadcrumbClicked)="handleCancel()"></mwo-scheduler-modifier-header>
  <div class="row-display">
    <div class="column-display">
      <mwo-edit-day-schedule-item [activeEdit]="true"
                                  [timeSlot]="slotToEdit"
                                  class="slot-display"></mwo-edit-day-schedule-item>
      <mwo-slot-time-picker (onTimePickerChange)="onSlotTimePickerChanged($event)"
                            *ngIf="slotToEdit.startTime != undefined && slotToEdit.endTime != undefined"
                            [slotBeginningHour]="slotToEdit.startTime[0]"
                            [slotBeginningMinute]="slotToEdit.startTime[1]"
                            [slotEndHour]="slotToEdit.endTime[0]"
                            [slotEndMinute]="slotToEdit.endTime[1]"
                            class="edit-slot-time-picker"></mwo-slot-time-picker>
      <mwo-slot-time-picker (onTimePickerChange)="onSlotTimePickerChanged($event)"
                            *ngIf="slotToEdit.startTime == undefined && slotToEdit.endTime == undefined"
                            [slotBeginningHour]="0"
                            [slotBeginningMinute]="0"
                            [slotEndHour]="23"
                            [slotEndMinute]="59"
                            class="edit-slot-time-picker"></mwo-slot-time-picker>
      <div *ngIf="slotToEdit.event" class="toggle-container">
        <mat-slide-toggle (change)="onShuffleChange($event.checked)" [(ngModel)]="slotToEdit.shuffle" color="primary">
          {{ 'playlist.shuffle' | translate }}
        </mat-slide-toggle>
      </div>
    </div>
    <mwo-playlist-folder-display (onPlaylistSelected)="handlePlaylistSelected($event)"
                                 (onPlayruleSelected)="handlePlayruleSelected($event)"
                                 [activeSlot]="slotToEdit"
                                 class="edit-slot-playlist-folder"></mwo-playlist-folder-display>
  </div>
  <div class="buttons-bottom">
    <mwo-main-button (onClick)="handleCancel()" text="{{'planning.cancel' | translate}}"></mwo-main-button>
    <mwo-main-button (onClick)="handleValidate()"
                     [disabled]="slotToEdit.event == undefined && slotToEdit.tempo == undefined"
                     text="{{'planning.validate' | translate}}"></mwo-main-button>
  </div>
</div>
